import { createFileRoute } from '@tanstack/react-router'
import { NavigationSettingsPage } from '../../../modules/settings/navigation-settings-page'
import { SettingsShell } from '../../../modules/settings/settings-shell'

export const Route = createFileRoute('/_authed/settings/navigation')({
  component: () => (
    <SettingsShell>
      <NavigationSettingsPage />
    </SettingsShell>
  ),
})
